import PlaySVG from '@public/icons/play2.svg';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import GalleryPopup, { GALLERY_POPUP_NAME } from '@/shared/components/popups/GalleryPopup/GalleryPopup';
import Image from '@/shared/components/shared/Image';

type Props = React.HTMLAttributes<HTMLElement>;

const StreetGallery = forwardRef<HTMLButtonElement, Props>((props, ref) => {
    const { openPopup } = useSetOpenedPopupsState();

    return (
        <>
            <button
                {...props}
                ref={ref}
                className={classNames('text-xxs street-gallery-opener', props.className)}
                onClick={(event) => {
                    openPopup(GALLERY_POPUP_NAME);
                    props.onClick?.(event);
                }}
            >
                <Image
                    src="/img/gallery/preview.jpg"
                    width={496}
                    height={420}
                    sizes="250px"
                    alt=""
                    className="street-gallery-opener__img"
                />
                <PlaySVG className="street-gallery-opener__icon" />
                <span className="street-gallery-opener__text">Как это было</span>
            </button>

            <GalleryPopup
                title="План уличной экспозиции 2024"
                slides={[
                    {
                        title: 'Индивидуальный 7',
                        img: { src: '/img/gallery/1.jpeg', width: 1920, height: 1080 },
                        square: 43,
                        price: 'по запросу',
                    },
                    {
                        title: 'Индивидуальный 14',
                        img: { src: '/img/gallery/2.jpeg', width: 1920, height: 1080 },
                        square: 50.5,
                        price: 'по запросу',
                    },
                ]}
            />
        </>
    );
});

StreetGallery.displayName = 'StreetGallery';

export default StreetGallery;
